export const OUTCOMES = ['connected', 'no_answer', 'busy', 'wrong_number', 'callback', 'not_interested', 'completed', 'other'];
export const MANUAL_STATUSES = ['completed', 'no_answer', 'busy', 'failed', 'cancelled'];
const ACTIVE = new Set(['reserved', 'submitted', 'submission_unknown', 'ringing', 'connected']);
export const isActiveAttempt = (attempt) => !attempt?.resolvedAt && ACTIVE.has(attempt?.technicalStatus);

export function buildCallsQuery({ profileId, taskId, assignedToId, scope = 'mine', period = 'all', needsOutcome = false, offset = 0 } = {}) {
  const query = new URLSearchParams({ scope, period, limit: '25', offset: String(offset), timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC' });
  if (profileId) query.set('profileId', profileId);
  if (taskId) query.set('taskId', taskId);
  if (assignedToId) query.set('assignedToId', assignedToId);
  if (needsOutcome) query.set('needsOutcome', 'true');
  return query.toString();
}

export function toLocalDateTime(value) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return '';
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}

export function buildEditorPayload(mode, form) {
  const required = () => { throw new Error('calls.validation.required'); };
  const timestamp = (value) => {
    if (!value || Number.isNaN(Date.parse(value))) required();
    return new Date(value).toISOString();
  };
  const version = Number.isInteger(form.version) ? { version: form.version } : {};
  if (mode === 'outcome') {
    if (!form.outcome) required();
    const notes = String(form.notes || '').trim();
    if (form.resolveSubmission && !notes) throw new Error('calls.validation.resolveSubmission');
    return { outcome: form.outcome, notes, ...(form.resolveSubmission ? { resolveSubmission: true } : {}), ...version };
  }
  if (!form.profileId) required();
  if (mode === 'plan') {
    if (!form.assignedToId || !String(form.subject || '').trim()) required();
    return { profileId: form.profileId, assignedToId: form.assignedToId, scheduledAt: timestamp(form.scheduledAt), subject: form.subject.trim(), notes: String(form.notes || '').trim(), status: form.status || 'planned', ...version };
  }
  const startedAt = timestamp(form.startedAt);
  const endedAt = form.endedAt ? timestamp(form.endedAt) : null;
  const durationSeconds = form.durationSeconds === '' || form.durationSeconds == null ? null : Number(form.durationSeconds);
  if ((endedAt && Date.parse(endedAt) < Date.parse(startedAt)) || (durationSeconds !== null && (!Number.isInteger(durationSeconds) || durationSeconds < 0))) throw new Error('calls.validation.duration');
  return { profileId: form.profileId, taskId: form.taskId || null, startedAt, endedAt, durationSeconds, technicalStatus: form.technicalStatus || 'completed', outcome: form.outcome || null, notes: String(form.notes || '').trim() };
}

export function filterCallsMenu(items, enabled) {
  return items.filter((item) => item.requiresModule !== 'calls' || enabled).map((item) => (
    Array.isArray(item.children) ? { ...item, children: filterCallsMenu(item.children, enabled) } : item
  )).filter((item) => !Array.isArray(item.children) || item.children.length > 0);
}

export function formatCallDate(value, locale) {
  if (!value || Number.isNaN(Date.parse(value))) return '—';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}
